import "./monthlyForm.scss";

import { format } from "date-fns";
import * as React from "react";
import { connect } from "react-redux";
import { actions } from "react-redux-form";
import { withRouter } from "react-router";

import * as PropTypes from 'prop-types'; 
import { IHistory } from "../../../interfaces";
import { QuestionModel } from "../../../model/QuestionModel";
import { parseJwt } from "../../../services/loginService";
import {
  getMonthlyFormQuestions,
  submitMonthlyForm
} from "../../../services/monthlyFormService";
import { dispatch, marshallAnswers, checkAnswerForYesOrNo, getPageTitle } from "../../../utils/generalUtils";
import { Async } from "../../reusableComponents/Async";
import { BasePage } from "../../reusableComponents/BasePage";
import { ErrorPage } from "../../reusableComponents/ErrorPage";
import { Form } from "../../reusableComponents/FormComponents/Form";
import { FormFooter } from "../../reusableComponents/FormComponents/FormFooter";
import { ImageUpload } from "../../reusableComponents/ImageUpload";
import { Loader } from "../../reusableComponents/Loader";
import { MonthlyUSTSpill, questionData } from "../../../constants/generals";
import { RenderQuestion } from "../../reusableComponents/FormComponents/RenderQuestion";
import { MonthlyFormModel } from '../../../model/MonthlyFormModel';

export interface IMonthlyUSTSpillFormProps {
  questions: QuestionModel[];
  type: string;
  date: string;
  plantId: string;
  userUID: string;
  userName: string;
  formId: string;
  followUpAction: string;
  history: IHistory;
  formInstance: MonthlyFormModel;
  form;
}

export interface IMonthlyUSTSpillFormState {
  date: string;
}

export class MonthlyUSTSpillFormImpl extends React.PureComponent<
  IMonthlyUSTSpillFormProps,
  IMonthlyUSTSpillFormState
> {
  constructor(props: IMonthlyUSTSpillFormProps) {
    super(props);
    this.state = {
      date: props.date
    };
  }
  loadDefaultValues = () => {
    const answers = [];
    if (this.props.formId) {
      this.props.questions.forEach(instance => {
        dispatch(
          actions.change(
            `forms.monthlyUSTSpill.${instance.props.quesNum}`,
            checkAnswerForYesOrNo(instance.props.answer)
          )
        );
      });
    }
  };
  loadValues = () => {
    this.loadDefaultValues();
    dispatch(
      actions.change(
        "forms.monthlyUSTSpill.1",
        format(new Date(this.props.date), "MM/DD/YYYY")
      )
    );
    dispatch(actions.change("forms.monthlyUSTSpill.2", this.props.userName));
  };

  promise = async () => {
    await getMonthlyFormQuestions(this.props.type, this.props.formId);
  };

  refs: {
    images: ImageUpload;
  };
  getChildContext() {
    return { formModel: 'forms.monthlyUSTSpill' };
  } 

  static childContextTypes = {
      formModel: PropTypes.string
  };

  handleFormSubmit = values => {
    const answer = marshallAnswers(values);
    const data = {
      UserId: this.props.userUID,
      PlantId: this.props.plantId,
      InspectionID: "MonthlyUSTSpill",
      followUp_Required: false,
      Date: format(new Date(this.props.date), "MM-DD-YYYY"),
      Completed: true,
      Answers: answer,
      ImageUrls: [],
      DeletedImages : this.props.form.monthlyUSTSpill.deletedImages || [],
      SignatureUrls: [],
      followUp_form: Number(this.props.followUpAction),
      AssociatedTo: null
    };
    return submitMonthlyForm(
      data,
      this.props.history,
      this.refs.images.value,
      this.props.formId
    );
  };

  renderContent = () => {
    const Buttons = [
      {
        label: "Yes",
        value: "Yes"
      },
      {
        label: "No",
        value: "No"
      }
    ];
    return (
      <Form
        model="forms.monthlyUSTSpill"
        onSubmit={this.handleFormSubmit}
        className="monthly-ust-spill-form form"
        loadDefaultValues={this.loadValues}
      >
        <div className="information">
          <h3>UST Spill Container Inspection Form</h3>
          <ul>
            <li>
              This form is used to document compliance with the periodic
              inspection requirement for spill containers.
            </li>
            <li>
              Inspect all spill containers to ensure that their sides, bottoms,
              and any penetration points are liquid tight.
            </li>
            <li>
              Remove and properly dispose of any liquids or debris found during
              the inspection within 96 hours of discovery.
            </li>
            <li>Complete this form monthly.</li>
            <li>
              If you have questions on how to complete this form, please contact
              your Environmental Manager at 972-621-0999 or 817-917-3507.
            </li>
          </ul>
        </div>
        <div className="date">Date: {format(new Date(), "MM-DD-YYYY")}</div>
        {MonthlyUSTSpill &&
          MonthlyUSTSpill.map((quesData, index) => (
            <RenderQuestion
              formId={this.props.formId}
              key={index}
              uniqueValue={index}
              quesNo={quesData.Question_Num && quesData.Question_Num.toString()}
              question={quesData.Question}
              questionType={quesData.Questiontype}
              model="monthlyUSTSpill"
              CommentQuestionNum={
                quesData.CommentQuestionNum ? quesData.CommentQuestionNum : null
              }
              buttons={Buttons}
              customLabel={quesData.customLabel && quesData.customLabel}
              isCheck={true}
            />
          ))}
        <ImageUpload
          ref="images"
          multi={true}
          label="Select Images to Upload:"
          defaultValue={this.props.formInstance && this.props.formInstance.props.ImageUrls }
        />
        <FormFooter />
      </Form>
    );
  };

  render() { 
    let pageTitle = `${getPageTitle(this.props.type, 'monthly', this.props.date, 'inspection')} `;
    return (
      <BasePage pageTitle={pageTitle}>
        <Async
          identifier="MonthlyUSTSpillForm"
          promise={this.promise}
          loader={<Loader type="async" />}
          content={this.renderContent()}
          error={<ErrorPage />}
        />
      </BasePage>
    );
  }
}
export function mapStateToProps(state, ownProps) {
  const type = "MonthlyUSTSpill";
  const date = ownProps.match.params.date;
  const followUpAction = ownProps.match.params.followUpAction;
  const questions = QuestionModel.getAllByType(type);
  const firstName = parseJwt(state.login.get("token")).First_Name;
  const lastName = parseJwt(state.login.get("token")).Last_Name;  
  const formInstance = MonthlyFormModel.get(ownProps.match.params.formId); 
  return {
    plantId: ownProps.match.params.plantId,
    userUID: state.login.get("UniqueId"),
    followUpAction,
    type,
    questions,
    date,
    userName: `${firstName} ${lastName}`,
    formId: ownProps.match.params.formId,form: state.forms, formInstance
  };
}
export const MonthlyUSTSpillForm = withRouter(
  connect<{}, {}, IMonthlyUSTSpillFormProps>(mapStateToProps)(
    MonthlyUSTSpillFormImpl as any
  )
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Forms/MonthlyForm/MonthlyUSTSpillForm.tsx